import "./GiftOfGenerosity.module.css";
import Header from "@/reusable_sections/Header";
import UnderstandingDana from "./sections/UnderstandingDana";
import SupportOurTeachings from "./sections/SupportOurTeachings";
import Footer from "@/reusable_sections/Footer";
export default function GiftOfGenerosityPage() {
  return <div>
      <Header />
      <UnderstandingDana />
      <SupportOurTeachings />
      <Footer />
    </div>;
}